import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentStatus } from 'src/app/common';
import { PaymentService } from 'src/app/services/payment.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-payment-detail',
  templateUrl: './payment-detail.component.html',
  styleUrls: ['./payment-detail.component.scss']
})
export class PaymentDetailComponent implements OnInit {

  constructor(private route: ActivatedRoute, private paymentService: PaymentService, private router: Router,
    private sharedService: SharedService) { }

  payment: any;
  PaymentStatus = PaymentStatus;
  async ngOnInit() {
    const pid = this.route.snapshot.params['id'] || this.route.snapshot.queryParams['pid'];
    if (!pid) return;
    this.payment = await this.paymentService.get(pid);
  }

  async pay(manualToken?: string) {
    await this.paymentService.retry(this.payment.Id, false, manualToken);
  }

  completed() {
    this.router.navigate(['/']);
  }

  get isMe() { return this.payment.Item?.id == this.sharedService.me?.Id }
  get name() { return this.payment?.Item?.name || this.payment?.Item?.Name || 'کاربر'; }
  get mobile() { return '0' + (this.payment?.Item?.maskedUsername || this.payment?.Item?.MaskedUsername); }
}
